export namespace LoadingActions {
  export class SetLoading {
    static readonly type = '[Loading] Set Loading';
    /**
     *
     */
    constructor(public loading: boolean) {}
  }
  export class SetCommandLoading {
    static readonly type = '[Command Loading] Set Command Loading';
    /**
     *
     */
    constructor(public commandLoading: boolean) {}
  }
}
